/**
 * Payments API — product-facing checkout (provider is chosen by the backend).
 * Endpoints: /api/payments/*
 */
import apiClient, { createAuthConfig, isMockApi } from "../client";
import { mockCreatePaymentOrder, mockCreatePaymentSubscription, mockConfirmPayment, mockGetPayment } from "../mocks";

export const createCreditOrder = async (token, packageId, currency) => {
  if (isMockApi) return mockCreatePaymentOrder();
  const body = { package_id: packageId };
  if (currency) body.currency = currency;
  const response = await apiClient.post(
    "/api/payments/orders",
    body,
    createAuthConfig(token)
  );
  return response.data;
};

export const createSubscriptionCheckout = async (token, packageId, currency) => {
  if (isMockApi) return mockCreatePaymentSubscription();
  const body = { package_id: packageId };
  if (currency) body.currency = currency;
  const response = await apiClient.post(
    "/api/payments/subscriptions",
    body,
    createAuthConfig(token)
  );
  return response.data;
};

export const confirmPayment = async (token, payload) => {
  if (isMockApi) return mockConfirmPayment();
  const response = await apiClient.post(
    "/api/payments/confirm",
    payload,
    createAuthConfig(token)
  );
  return response.data;
};

export const getPayment = async (token, lzPaymentId) => {
  if (isMockApi) return mockGetPayment();
  const response = await apiClient.get(
    `/api/payments/${encodeURIComponent(lzPaymentId)}`,
    createAuthConfig(token)
  );
  return response.data;
};

export default {
  createCreditOrder,
  createSubscriptionCheckout,
  confirmPayment,
  getPayment,
};
